import { useEffect, useState } from "react";
import { FetchActor } from "./util";
import { PromiseFn } from "./index";

export function useFetchActorLoading<T extends PromiseFn>(
  fetchActor: FetchActor<T>
) {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(fetchActor.getSnapshot().matches("fetching"));
    const s1 = fetchActor.on("fetching", () => setLoading(true));
    const s2 = fetchActor.on("fetched", () => setLoading(false));
    const s3 = fetchActor.on("error", () => setLoading(false));
    return () => {
      s1.unsubscribe();
      s2.unsubscribe();
      s3.unsubscribe();
    };
  }, [fetchActor]);
  return loading;
}
